export default __webpack_public_path__ + "static/media/bci-10.d1b76f92.svg";